import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import EmailSent from "../../assets/mail-sent.svg";
import Button from "../../components/Button";
import styles from "./ResetSent.module.css";

const ResetSent = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email;

  useEffect(() => {
    if (!email) {
      navigate("/login", { replace: true });
    }
  }, [email]);

  if (!email) {
    return null;
  }

  return (
    <div className={styles.container}>
      <img className={styles.illustration} src={EmailSent} alt="" />
      <div className={styles.containerInner}>
        <h1 className={styles.title}>Password reset email sent</h1>
        <div>{email}</div>
        <div>
          We've sent you a secure link to safely reset your password and keep
          your account protected.
        </div>
      </div>
      <Button
        type="accent"
        fullWidth={true}
        buttonProps={{
          onClick: () => {
            navigate("/login");
          },
        }}
      >
        Continue
      </Button>
    </div>
  );
};

export default ResetSent;
